import { CardContentCard } from './card/content-card';
import { CardInfoCard } from './card/info-card';
import { CardMetaCard } from './card/meta-card';
import { CardProductCard } from './card/product-card';
import { CardServiceCard } from './card/service-card';
import { ContentIntro } from './content/intro';
import { InternSecondaryDividerLink } from './intern/secondary-divider-link';
import { LinkInternalLink } from './link/internal-link';
import { Tag } from './tag';

/**
 * Model definition for service-teaser-gallery
 */
export interface ServiceTeaserGallery {
  __contentType: 'service-teaser-gallery';
  id: string;
  name?: string;
  intro?: ContentIntro;
  content?: (CardContentCard | CardInfoCard | CardMetaCard | CardProductCard | CardServiceCard)[];
  enableMultiTagFilter?: boolean;
  filterType: 'OR' | 'AND';
  data?: { [key: string]: unknown };
  layout?:
    | 'O_F_2_3_F_L'
    | 'O_F_2_3_2_F'
    | 'O_F_2_2_F'
    | 'O_F_2_3_3_F_L'
    | 'O_F_3_3_F_L'
    | 'O_2_1r_3_F_L'
    | 'O_F_2_1l_3_F_L'
    | 'O_F_3_R_R_R_2_F_L'
    | 'J_3'
    | 'J_2'
    | 'SS'
    | 'R*'
    | 'F_L';
  dividerLink?: LinkInternalLink;
  tags?: Tag[];
  tagCounts?: { [key: string]: number };
  secondaryDividerLinks?: InternSecondaryDividerLink[];
}

export function isServiceTeaserGallery(obj: { __contentType?: string }): obj is ServiceTeaserGallery {
  return obj.__contentType === 'service-teaser-gallery';
}
